module.exports = __webpack_public_path__ + "static/media/large_profile.a4ffd7ed.svg";